import React from 'react'
import {useSelector} from 'react-redux'
import PropTypes from 'prop-types'
import {withRouter} from 'react-router-dom'
import KeepShoppingButton from '../../shared/closebutton/keepShoppingButton'
import Goback from '../../shared/goback'
import { getDataFromURL } from '../../../utilities/function/urlparams'

let CheckoutBreadcrumbs = (props) => {
  const { location } = props
  const {a , step } = getDataFromURL(location.search)
  if(a && step){
    const data = [{
      label: 'Account',
      step: 'account',
      onClick: (e)=>{
        e.preventDefault()
      }
    },{
      label: 'Payment',
      step: 'payment',
      onClick: (e)=>{
        e.preventDefault()
      }
    },{
      label: 'Finished',
      step: 'finished',
      onClick: (e)=>{
        e.preventDefault()
      }
    }]
    const renderList = () => {
      if(data && data.length > 0){
        const isLast = (index) => {
          if(index===data.length-1){
            return true
          }
          return false
        }
        const isSelected = (item) => {
          return item.step===step
        }
        const renderItem = () => {
          return data.map((item,index) => {
            const { label , onClick} = item
              return (
                <li key={index} className={`of-checkout-breadcrumbs__item clearfix${isSelected(item)?' of-checkout-breadcrumbs__item--selected':''}`}>
                  <button type="button" className={`of-checkout-breadcrumbs__button${isSelected(item)?' text-font-2-100':' text-font-4-100'}`} onClick={onClick}>{label}</button>
                  {!isLast(index)?<i className={`icon icon-of-arrow of-checkout-breadcrumbs__icon text-font-4-100`} />:<></>}
                </li>
              )
          })
        }
        return (<ul className='of-checkout-breadcrumbs__list'>
          {renderItem()}
        </ul>)
      }
    }
    return (
      <div className='of-checkout-breadcrumbs'>
        {renderList()}
      </div>
    )
  }
 return (<></>)
}
CheckoutBreadcrumbs = withRouter(CheckoutBreadcrumbs)
CheckoutBreadcrumbs.propTypes = {
  location: PropTypes.any
}

let CheckoutHeader = (props) => {
  const { location, checkToken, history } = props
  const {step,a} = getDataFromURL(location.search)
  const { SwitchForm } = useSelector(state => ({
    SwitchForm : state.app.SwitchForm
  }))

  const renderHeading = () =>{
    const renderHeadingMain = (heading) => {
      return (
        <div className={'of-checkout-header__column of-checkout-header__column--heading'}>
          <div className='of-checkout-header__heading'>
            <div className={`of-checkout-header__heading-icon-of-wrapper${heading==='All Finished!'?' status-background-1-100':' primary-background-1-100'}`}>
              <i className={`of-checkout-header__heading-icon${heading==='All Finished!'?' icon-of-tick-solid':' icon-of-account'}`} />
            </div>
            <div className='of-checkout-header__heading-text text-font-1-100'>{heading}</div>
          </div>
        </div>
      )
    }
    const renderCheckoutHeading = () => {
      switch (step) {
        case 'finished':
          return (renderHeadingMain('All Finished!'))
        case 'paypal':
          return (<></>)
        case 'payment':
          return (renderHeadingMain('Payment'))
        default:
          return (renderHeadingMain('Register/Login'))
      }
    }
    const renderSwitchHeading = () =>{
      switch (step){
        case 'login':
          return (renderHeadingMain('Login'))
        case 'select-service':
          return (renderHeadingMain('Your Service'))
        case 'finished':
          return (renderHeadingMain('All Finished'))
        default:
          return (renderHeadingMain('Your Details'))
      }
    }
    switch (a){
      case 'checkout':
        return (renderCheckoutHeading())
      case 'switch':
        return (renderSwitchHeading())
      default:
        return (<></>)
    }
  }
  const renderBreadCrumbs = () =>{
    if(step==="account" || step==="payment"){
      return(
        <div className='of-checkout-header__column of-checkout-header__column--breadcrumbs'>
          <CheckoutBreadcrumbs />
        </div>
      )
    }
    return (<></>)
  }
  const renderCloseButton = () =>{
    const renderKeepShoppingButton = () => {
      return (
        <div className='of-checkout-header__column of-checkout-header__column--keepshopping'>
          <KeepShoppingButton className={'of-checkout-header__button'} label={a==='switch'?'Go Back':''}/>
        </div>
      )
    }
    const renderCheckoutCloseButton = () => {
      if(step==='paypal'){
        return (<></>)
      }
      return(renderKeepShoppingButton())
    }
    const renderSwitchCloseButton = () => {
      if(step === 'select-service' || step === 'login'){
        if(!checkToken ||
            (checkToken && (checkToken.status==="error" ||
            !checkToken.status))
        ){
          return(
            <div className='of-checkout-header__column of-checkout-header__column--keepshopping'>
              <Goback className={'of-checkout-header__goback text-font-3-100'} onClick={()=>{
                try {
                  if(SwitchForm && SwitchForm.values) {
                    localStorage.setItem('SwitchForm',JSON.stringify(SwitchForm.values))
                  }
                  history.push(`${history.location.pathname}?a=switch`)
                }catch (e) {}
              }} isButton={true}>Go Back</Goback>
            </div>
          )
        }
      }
      return(renderKeepShoppingButton())
    }
    switch (a) {
      case 'switch':
        return (renderSwitchCloseButton())
      default:
        return (renderCheckoutCloseButton())
    }
  }

  return (
    <div className='of-checkout-header'>
      {renderHeading()}
      {renderBreadCrumbs()}
      {renderCloseButton()}
    </div>
  )
}

CheckoutHeader.propTypes = {
  location: PropTypes.any,
  history: PropTypes.any,
  checkToken:PropTypes.any
}

CheckoutHeader = withRouter(CheckoutHeader)

export default CheckoutHeader